import * as React from "react";
import { UitkText } from "uitk-react-text";
import { DecorateEditorialHtml } from "../../../ContentUtilities";
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } from "bernie-view";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 3;
export const CardComparisonMobileApplyNowEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [horizontalLine, applyNowTitle, applyNowText] = React.useMemo(
    () => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />),
    []
  );

  return (
    <Viewport>
      <ViewExtraLarge />
      <ViewLarge />
      <ViewMedium>
        <div>
          {horizontalLine}
          <UitkText align="center" size={400} weight="medium">
            <UitkSpacing padding={{ medium: { blockstart: "two" } }}>
              <div>{applyNowTitle}</div>
            </UitkSpacing>
          </UitkText>
          <UitkText align="center" size={400}>
            <UitkSpacing padding={{ medium: { blockstart: "one" } }}>
              <div>{applyNowText}</div>
            </UitkSpacing>
          </UitkText>
          {horizontalLine}
        </div>
      </ViewMedium>

      <ViewSmall>
        <div>
          {horizontalLine}
          <UitkText align="center" size={400} weight="medium">
            <UitkSpacing padding={{ medium: { blockstart: "two" } }}>
              <div>{applyNowTitle}</div>
            </UitkSpacing>
          </UitkText>
          <UitkText align="center" size={400}>
            <UitkSpacing padding={{ small: { blockstart: "one" } }}>
              <div>{applyNowText}</div>
            </UitkSpacing>
          </UitkText>
          {horizontalLine}
        </div>
      </ViewSmall>
    </Viewport>
  );
};

export default CardComparisonMobileApplyNowEditorial;
